import RemoveButton from './RemoveButton.vue'

export default {
  install(Vue) {
    Vue.component(RemoveButton.name, RemoveButton)
  }
}
